import { createFileRoute } from "@tanstack/react-router";
import { BusinessAppsPage } from "@/components/blocks/services/BusinessAppsPage";
import { translations } from "@/lib/i18n";
import {
	buildPageBreadcrumb,
	buildPageFaq,
	buildPageSeo,
	buildServiceStructuredData,
	loadPageLocale,
} from "@/lib/page-seo";

export const Route = createFileRoute(
	"/{-$locale}/services/applications-metier",
)({
	component: BusinessAppsPage,
	loader: loadPageLocale,
	head: ({ loaderData }) => {
		if (!loaderData) return {};
		const { locale } = loaderData;
		return buildPageSeo("businessApps", locale, {
			structuredData: [
				buildServiceStructuredData("businessApps", locale),
				buildPageBreadcrumb(locale, ["businessApps"]),
				buildPageFaq(translations[locale].businessApps.faq.items),
			],
		});
	},
});
